var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"demo-chart-bag"}},[_c('div',{attrs:{"id":"energyChart"}},[_c('div',{attrs:{"id":"legend"}}),_vm._v(" "),_c('div',{attrs:{"id":"totalValue"}},[_vm._v("\n      累積耗電量："),_c('p')])])])
}]

export { render, staticRenderFns }